export const DOW_LONG  = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun']
export const DOW_SHORT = ['M','T','W','T','F','S','S']
export const SLOT_KEYS = ['breakfast','lunch','dinner'] as const
export const SLOT_LABELS: Record<string, string> = {
  breakfast: 'Breakfast', lunch: 'Lunch', dinner: 'Dinner',
}

const pad = (n: number) => (n < 10 ? '0' + n : '' + n)
export const isoDate = (d: Date) =>
  d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())

export function addDays(d: Date, n: number) {
  const x = new Date(d); x.setDate(x.getDate() + n); return x
}

export function startOfWeekMon(d: Date) {
  const x = new Date(d)
  const day = x.getDay()
  const diff = day === 0 ? -6 : 1 - day
  x.setDate(x.getDate() + diff)
  x.setHours(0, 0, 0, 0)
  return x
}

export const startOfMonth = (d: Date) => new Date(d.getFullYear(), d.getMonth(), 1)
export const monthGridStart = (d: Date) => startOfWeekMon(startOfMonth(d))

export function formatWeekRange(weekStart: Date) {
  const end = addDays(weekStart, 6)
  const m1 = weekStart.toLocaleDateString('en-US', { month: 'long' })
  const m2 = end.toLocaleDateString('en-US', { month: 'long' })
  if (weekStart.getMonth() === end.getMonth()) {
    return `${m1} ${weekStart.getDate()} – ${end.getDate()}`
  }
  return `${m1.slice(0,3)} ${weekStart.getDate()} – ${m2.slice(0,3)} ${end.getDate()}`
}
